import Vue from "vue";
import App from "./App.vue";
import {router} from "./router";
import store from "@/store";
import vuetify from "./plugins/vuetify";
import axios from 'axios';
import VueTheMask from 'vue-the-mask'
import Helper from './helper'
import wb from "./registerServiceWorker";

Vue.prototype.$workbox = wb;
Vue.prototype.$http = axios;
Vue.prototype.$urlApi = process.env.VUE_APP_URL_API;
Vue.prototype.$urlApp = process.env.VUE_APP_URL_APP;
Vue.prototype.$helper = Helper;

Vue.use(VueTheMask);

//Components
import Alert from '@/components/shared/Alert'
import LayoutDashboard from '@/components/shared/LayoutDashboard'
import TooltipButton from '@/components/shared/TooltipButton'
import ModalPrint from '@/components/shared/ModalPrint'
import ModalConfirmacao from '@/components/shared/ModalConfirmacao'
import './registerServiceWorker'

Vue.component('Alert', Alert)
Vue.component('LayoutDashboard', LayoutDashboard)
Vue.component('TooltipButton', TooltipButton)
Vue.component('ModalPrint', ModalPrint)
Vue.component("ModalConfirmacao", ModalConfirmacao);

// Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");